import { React, useState, useEffect } from "react";
import PopUpHoldResults from "../../client/betfair-games/betfair_games_result_text/hold";
import PopUpBlackJackResults from "../../client/betfair-games/betfair_games_result_text/blackjack";
import PopUpBacaratResults from "../../client/betfair-games/betfair_games_result_text/bacarat";
import PopUpHiloResults from "../../client/betfair-games/betfair_games_result_text/hilo";
import PopUpDerbyResults from "../../client/betfair-games/betfair_games_result_text/derby";

const PopUpBetfairResults = ({ resultsData, catMid, marketType }) => {
  ///

  const resultData = resultsData;
  console.log(resultData);

  if (!resultsData) return null;

  const dataObj = resultsData;

  const win1 = dataObj.rnr1_status;
  const win2 = dataObj.rnr2_status;
  const win3 = dataObj.rnr3_status;
  const win4 = dataObj.rnr4_status;

  const bgCls1 = win1 === "WINNER" ? "bgwinner" : "bgLoser";
  const bgCls2 = win2 === "WINNER" ? "bgwinner" : "bgLoser";
  const bgCls3 = win3 === "WINNER" ? "bgwinner" : "bgLoser";
  const bgCls4 = win4 === "WINNER" ? "bgwinner" : "bgLoser";

  const tdCls1 = win1 === "WINNER" ? "TdResultsWin" : "";
  const tdCls2 = win2 === "WINNER" ? "TdResultsWin" : "";
  const tdCls3 = win3 === "WINNER" ? "TdResultsWin" : "";
  const tdCls4 = win4 === "WINNER" ? "TdResultsWin" : "";

  const cardsArr = dataObj.cards_desc?.split(",");
  const rnr1Arr = dataObj.rnr1_desc?.split(",");
  const rnr2Arr = dataObj.rnr2_desc?.split(",");
  const rnr3Arr = dataObj.rnr3_desc?.split(",");
  const rnr4Arr = dataObj.rnr4_desc?.split(",");
  const getCardImageResult = (cardValue) => {
    if (cardValue === "NOT AVAILABLE") {
      return `/assets/images/bpstudio/cards/card_simple_omaha_back_bf.svg`;
    }

    if (["28", "33", "39", "40"].includes(cardValue)) {
      return `/assets/images/bpstudio/cards/card_simple_${cardValue}.png`;
    }

    return `/assets/images/bpstudio/cards/card_simple_${cardValue}.svg`;
  };
  const tableStyle = { width: "100%", borderCollapse: "collapse" };
  const rowFlexStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-evenly",
    background: "transparent"
  };
  const tdResultsStyle = {
    padding: 8,
    minWidth: 180,
    boxSizing: "border-box"
  };
  const playerCardsStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    overflowWrap: "break-word"
  };
  const playerNameStyle = {
    fontWeight: "bold",
    textAlign: "center",
    width: "100%"
  };
  const cardImagesStyle = {
    display: "flex",
    justifyContent: "center",
    gap: 3,
    flexWrap: "wrap",
    width: "100%"
  };
  const cardImgStyle = {
    width: 40,
    height: 60,
    objectFit: "cover",
    borderRadius: 5
  };
  const playerStatusStyle = {
    color: "#000",
    marginTop: 5,
    fontSize: 14,
    fontWeight: "bold",
    textAlign: "center",
    width: "100%"
  };
  const formatDateTime = (date) => {
    if (!date) return "";

    const d = new Date(date);

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");

    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const seconds = String(d.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };
  return (
    <>
      <style>{`
        .TdResults {
            padding: 0;
            vertical-align: top;
            flex: 1 1 auto;
            box-sizing: border-box;
            max-width: calc(33.33% - 20px);
            min-width: 120px;
            background: linear-gradient(#535353, #0f0f0f);
            border-radius: 10px;
            margin: 1px;
        }
        .bgwinner {
            border-radius: 10px;
            background-color: #cf8d2e !important;
        }
        .bgLoser {
            border-radius: 10px;
            background-color: #cf3f3f !important;
        }
        .TdResultsWin {
            background: #008000 !important;
        }
      `}</style>

      <div id="ResultsData">
        <div className="left-content site_family">
          {/*hold, turbo-hold, omaha*/}
          <div style={{ display: marketType == 33 || marketType == 34 || marketType == 39 ? "" : "none" }} >
            <PopUpHoldResults
              resultsData={resultsData}
              catMid={catMid}
              marketType={marketType}
            />
          </div>
          {/*blackjack, turbo-blackjack*/}
          <div style={{ display: marketType == 37 || marketType == 38 ? "" : "none" }} >
            <PopUpBlackJackResults
              resultsData={resultsData}
              catMid={catMid}
              marketType={marketType}
            />
          </div>
          {/*bacarat, turbo-bacarat*/}
          <div style={{ display: marketType == 40 || marketType == 41 ? "" : "none" }} >
            <PopUpBacaratResults
              resultsData={resultsData}
              catMid={catMid}
              marketType={marketType}
            />
          </div>
          {/*hilo, turbo-hilo*/}
          <div style={{ display: marketType == 35 || marketType == 36 ? "" : "none" }} >
            <PopUpHiloResults
              resultsData={resultsData}
              catMid={catMid}
              marketType={marketType}
            />
          </div>
          {/*derby, turbo-derby*/}
          <div style={{ display: marketType == 62 || marketType == 63 ? "" : "none" }} >
            <PopUpDerbyResults
              resultsData={resultsData}
              catMid={catMid}
              marketType={marketType}
            />
          </div>
        </div>
      </div>
    </>
  );

};

export default PopUpBetfairResults;